import styled from 'styled-components'
import config from 'config'

const DisplayFormButton = styled.button`
  display: block;
  color: #777;
  border: 0;
  background: none;
  padding: 0;
  text-decoration: underline;
  cursor: pointer;
  outline: 0;
  text-align: left;
  overflow: hidden;
  white-space: nowrap;
`

const getImage = props => props.theme.select.icon.image
const getTransformation = props => (props.isFocused ? 'translateY(-2px)' : 'scaleY(-1) rotate(0.75turn)')

const DropdownIcon = styled.img.attrs(props => ({
  alt: 'arrow',
  src: `${config.url}/assets/${getImage(props)}`,
}))`
  cursor: pointer;
  transform: ${getTransformation};
  margin-right: 8px;
  vertical-align: middle;
`

const getBottomMargin = props => props.shouldBeDisplayed && '20px'
const DisplayFormContainer = styled.div`
  display: flex;
  margin: 0 0 ${getBottomMargin};
`

export {DropdownIcon, DisplayFormButton, DisplayFormContainer}
